import { useVariant } from "../../hooks/useVariant/useVariant";
import { getSizeAndFitAttributes } from "../ProductAccordion/components/ProductSizeAndFitAccordion/sizeAndFitUtils";
import { StandardProps } from "../componentMap";
import { SizeAndFitCtaUI } from "./SizeAndFitCtaUI";

export function SizeAndFitCta({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const { variant } = useVariant(product);
  const display = flags?.showSizeAndFitDetailsSkipLink.value === true;

  if (!display) {
    return null;
  }

  const variantAttributes = variant.attributes || [];
  const primaryAttributes = product.attributes || [];
  const allAttributes = [...primaryAttributes, ...variantAttributes];

  const categoryIds = product?.browsePageHierarchy?.map(
    (bph) => bph.categoryId,
  );
  const sizeAndFitAttributes = getSizeAndFitAttributes(
    categoryIds,
    allAttributes,
  );

  return sizeAndFitAttributes?.length > 0 ? <SizeAndFitCtaUI /> : null;
}
